var r=function r(o){return o.scrollTop};export{r as forceReflow};
//# sourceMappingURL=reflow.js.map
